<template>
    <tr :class="{'uk-text-danger': ((amount - amount_used) < 0)}">
        <td>{{ label }}</td>
        <td>
            <form-input
                v-if="monetary"
                :id="amount_name"
                :value="amount"
                type="float"
                :name="amount_name"
                glyph="dollar"
                :required="false"
                :editable="editable"
                @input="save_field"
            >
                <template v-slot:read_only>
                    ${{ amount | nibnut.number("0,0.00") }}
                </template>
            </form-input>
            <form-input
                v-else
                :id="amount_name"
                :value="amount"
                type="float"
                :name="amount_name"
                :required="false"
                :editable="editable"
                filter="0,0.0"
                width="3-10"
                align="right"
                @input="save_field"
            >
                <template v-slot:read_only>
                    {{ amount | nibnut.number("0,0.00") }} {{ unit }}
                </template>
                <span>{{ unit }}</span>
            </form-input>
        </td>
        <td>
            <form-input
                v-if="monetary"
                :id="amount_used_name"
                :value="amount_used"
                type="float"
                :name="amount_used_name"
                glyph="dollar"
                :required="false"
                :editable="editable"
                @input="save_field"
            >
                <template v-slot:read_only>
                    ${{ amount_used | nibnut.number("0,0.00") }}
                </template>
            </form-input>
            <form-input
                v-else
                :id="amount_used_name"
                :value="amount_used"
                type="float"
                :name="amount_used_name"
                :required="false"
                :editable="editable"
                filter="0,0.0"
                width="3-10"
                align="right"
                @input="save_field"
            >
                <template v-slot:read_only>
                    {{ amount_used | nibnut.number("0,0.00") }} {{ unit }}
                </template>
                <span>{{ unit }}</span>
            </form-input>
        </td>
        <td>
            <form-input
                 v-if="monetary"
                :id="total_name"
                :value="(amount - amount_used)"
                type="float"
                :name="total_name"
                glyph="dollar"
                :required="false"
                :editable="false"
                @input="save_field"
            >
                <template v-slot:read_only>
                    ${{ (amount - amount_used) | nibnut.number("0,0.00") }}
                </template>
            </form-input>
            <form-input
                v-else
                :id="total_name"
                :value="(amount - amount_used)"
                type="float"
                :name="total_name"
                filter="0,0.0"
                :required="false"
                :editable="false"
                width="3-10"
                align="right"
                @input="save_field"
            >
                <template v-slot:read_only>
                    {{ (amount - amount_used) | nibnut.number("0,0.00") }} {{ unit }}
                </template>
                <span>{{ unit }}</span>
            </form-input>
        </td>
    </tr>
</template>

<script type="text/javascript">
import handles_saving from "../../mixins/HandlesSaving"

import FormInput from "../../ui/FormInput"

export default {
    components: {
        FormInput
    },
    mixins: [handles_saving],
    computed: {
        amount_name () {
            return this.prefix
        },
        amount_used_name () {
            return this.prefix + "_used"
        },
        total_name () {
            return this.prefix + "_total"
        },
        amount () {
            if(!this.record) return 0
            return this.record[this.amount_name]
        },
        amount_used () {
            if(!this.record) return 0
            return this.record[this.amount_used_name]
        }
    },
    props: {
        record: {
            required: true
        },
        prefix: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        editable: {
            type: Boolean,
            default: true
        },
        monetary: {
            type: Boolean,
            default: false
        },
        unit: {
            type: String,
            default: "hrs"
        }
    }
}
</script>
